__webpack_require__.p = "https://beta.speakinglist.net/";